import { useQuery } from "react-query";

import { CustomerEquipment } from "../../models";
import { getAll } from "../../api/generic-api";
import { RQ } from "../../globals/enums";

export const useCustomerEquipmentsByCustomer = (customerId?: string) => {
  return useQuery<CustomerEquipment[], Error>(
    [RQ.CUSTOMER_EQUIPMENTS, customerId],
    () => getAll(`customer-equipment/customer/${customerId}`),
    {
      enabled: Boolean(customerId),
    }
  );
};
